import React from "react"

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material"

import { Trans } from "@lingui/macro"

interface AcceptMatchModalProps
{
    closeModal: () => void,
    callback: () => void,
}
interface AcceptMatchModalState
{
}
export class AcceptMatchModal extends React.Component<AcceptMatchModalProps, AcceptMatchModalState>
{
    render()
    {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    <Typography variant="h5">
                        <Trans id="md-accept-match-modal-title">Accetta match</Trans>
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        <Trans id="md-accept-match-modal-text">Sei sicuro di voler accettare il match?</Trans>
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ pr: 2 }}>
                    <Button onClick={this.props.closeModal}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 1,
                                width: 100
                            }}
                            disableElevation>
                        <Trans id={"md-accept-match-close-button"}>
                            Annulla
                        </Trans>
                    </Button>
                    <Button onClick={this.props.callback}
                            variant="contained"
                            sx={{
                                backgroundColor: 'secondary.main',
                                color: 'white',
                                mr: 1,
                                textTransform: "none",
                                width: 100
                            }}
                    >
                        <Trans id={"md-accept-match-confirm-button"}>Conferma</Trans>
                    </Button>
                </DialogActions>
            </Dialog >
        )
    }
}
